import {
    Directive,
    Input,
    forwardRef,
    OnDestroy,
    OnChanges,
    SimpleChanges,
    SimpleChange
} from '@angular/core'
import {
    NG_VALIDATORS,
    Validator,
    AbstractControl,
    ValidationErrors
} from '@angular/forms'
import { ConfiguracaoIntegracaoBandeiraValidators } from './configuracao-integracao-bandeira.validators'
import { last } from '@angular/router/src/utils/collection'
import { Subscription } from 'rxjs/Subscription'

@Directive({
    selector: '[colAtLeastOne]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: AtLeastOneDirective,
            multi: true
        }
    ]
})
export class AtLeastOneDirective implements Validator, OnChanges, OnDestroy {
    @Input() controls: AbstractControl[]

    @Input()
    set colAtLeastOne(value: boolean) {
        this.mustValidate = value
    }

    private control: AbstractControl
    private mustValidate: boolean
    private otherControlsSubscriptions: Subscription[]

    constructor() {
        this.mustValidate = true
    }

    validate(control: AbstractControl): ValidationErrors {
        this.control = control

        if (!this.mustValidate || !this.controls) {
            return null
        }

        return ConfiguracaoIntegracaoBandeiraValidators.atLeastOne(
            this.controls
        )(control)
    }

    ngOnChanges(changes: SimpleChanges) {
        this.handleInputChanges(changes)
    }

    ngOnDestroy() {
        if (this.otherControlsSubscriptions) {
            this.unsubscribeOthers()
        }
    }

    private subscribeToOthers(control: AbstractControl) {
        this.otherControlsSubscriptions = this.controls
            .filter(other => other !== control)
            .map(other => {
                return other.valueChanges.subscribe(() => {
                    control.updateValueAndValidity({ emitEvent: false })
                })
            })
    }

    private unsubscribeOthers() {
        this.otherControlsSubscriptions.forEach(subscription => {
            subscription.unsubscribe()
        })
        this.otherControlsSubscriptions = null
    }

    private handleInputChanges(changes: SimpleChanges) {
        if (changes.controls && valuesAreDiferent(changes.controls)) {
            if (this.otherControlsSubscriptions) {
                this.unsubscribeOthers()
            }

            if (this.control) {
                this.control.updateValueAndValidity({ emitEvent: false })

                if (this.controls) {
                    this.subscribeToOthers(this.control)
                }
            }
        }
    }
}

function valuesAreDiferent(change: SimpleChange) {
    const prev = change.previousValue
    const curr = change.currentValue

    if (change.firstChange || typeof prev !== typeof curr) {
        return true
    }

    if (Array.isArray(prev) && Array.isArray(curr)) {
        return !prev.every((prevItem, i) => {
            const currItem = curr[i]
            return prevItem === currItem
        })
    }

    return prev !== curr
}



// WEBPACK FOOTER //
// ./src/app/configuracao/configuracao-integracao/configuracao-integracao-bandeira/at-least-one.directive.ts